import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {addToast} from 'common/components/toast-area/toast-manager';
import {Toast} from 'common/components/toast-area';

import {areToastsEqual} from './utils';

/**
 * This is the declarative component way to add a toast, directly inside of a template. Internally it uses the classic "addToast" function.
 *
 * The toast is rendered in our global mp-toast-area component
 */
export class ToastPortal extends Component<UnknownObj> {
  _toast = null;
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
    };
  }

  get config() {
    return {
      template: () => null,
    };
  }

  set toast(toast: Toast) {
    if (toast && !areToastsEqual(toast, this._toast)) {
      addToast(toast);
    }
    this._toast = toast;
  }
}

export const ToastPortalEl = defineAndMakeJsxFactory(`mp-toast-portal`, ToastPortal);
